import { Link } from 'react-router-dom';
import { FolderPlus, Calculator, FileText, TrendingUp } from 'lucide-react';

export function DashboardPage() {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold text-navy mb-2">לוח בקרה</h1>
        <p className="text-slate-600">ניהול קייסים של לקוחות עסקיים וניתוחי אשראי</p>
      </div>

      {/* Quick Actions */}
      <div className="grid md:grid-cols-3 gap-4">
        <QuickActionCard
          to="/business/cases/new"
          icon={FolderPlus}
          title="פתיחת קייס חדש"
          description="ניתוח קבוצת חברות או עסקה חדשה"
          color="bg-business-primary"
        />
        <QuickActionCard
          to="/business/calculator"
          icon={Calculator}
          title="מחשבון מהיר"
          description="DSCR, לוח סילוקין, APR — ללא שמירה"
          color="bg-teal"
        />
        <QuickActionCard
          to="/business/templates"
          icon={FileText}
          title="תבניות תיק פנימי"
          description="תבניות למסמכי מו״מ מול בנקים"
          color="bg-business-accent"
        />
      </div>

      {/* Cases list */}
      <div className="card">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-semibold text-navy">קייסים פתוחים</h2>
          <Link to="/business/cases/new" className="text-sm text-business-primary font-medium hover:underline">
            + קייס חדש
          </Link>
        </div>

        <div className="text-center py-16 text-slate-500">
          <TrendingUp className="w-12 h-12 mx-auto mb-4 text-slate-300" />
          <p className="mb-2">אין קייסים פתוחים כרגע</p>
          <p className="text-sm">התחל בפתיחת קייס חדש כדי לנתח קבוצת חברות או עסקה</p>
        </div>
      </div>
    </div>
  );
}

function QuickActionCard({
  to,
  icon: Icon,
  title,
  description,
  color,
}: {
  to: string;
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  description: string;
  color: string;
}) {
  return (
    <Link
      to={to}
      className="card hover:shadow-md transition group"
    >
      <div className={`w-10 h-10 rounded-lg ${color} flex items-center justify-center mb-4`}>
        <Icon className="w-5 h-5 text-white" />
      </div>
      <h3 className="font-semibold text-navy mb-1 group-hover:text-business-primary transition">
        {title}
      </h3>
      <p className="text-sm text-slate-600">{description}</p>
    </Link>
  );
}
